import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const classicProjectSettingsSoftwareNotificationsIssueLogsRoute: InvariantJiraRoute = {
	name: 'classic-software-notifications-issue-logs',
	path: '/jira/software/c/projects/:projectKey/settings/notifications/issue-logs',
	query: ['projectId'],
};
